const isDevelopment = process.env.NODE_ENV === 'development';

// In development, use localhost. In production, use the deployed Vercel URL
export const API_URL = isDevelopment 
  ? 'http://localhost:3001' 
  : 'https://ccbe.vercel.app';

export const getApiUrl = (endpoint) => {
  // In development, use the full URL with localhost
  if (isDevelopment) {
    console.log('Development URL:', `${API_URL}${endpoint}`);
    return `${API_URL}${endpoint}`;
  }
  
  // In production, use the full URL to the backend
  console.log('Production URL:', `${API_URL}${endpoint}`);
  return `${API_URL}${endpoint}`;
};

// Configure fetch options for CORS
export const fetchOptions = {
  credentials: 'include', // Include credentials for CORS
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Origin': 'https://customconnectjewelry.com'
  },
  mode: 'cors' // Explicitly set CORS mode
};
